import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useGetAllCommonStudentInitialDataMutation } from 'slices/get/common';
import useService from 'views/default/useService';
import { PageHeader, LoadingSpinner, NoDataFound } from './CommonComponents';
import './common-components.css';
import './homework-beautiful.css';

const SubjectsView = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  let history = useHistory();
  const { checkAccessTime, fetchAccessToken } = useService();
  const [getAllCommonStudentInitialData] = useGetAllCommonStudentInitialDataMutation();

  const [subjectData, setSubjectData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Beautiful gradient colors for subject cards
  const subjectGradients = [
    { bg: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', icon: 'bi-book' },
    { bg: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', icon: 'bi-journal-text' },
    { bg: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)', icon: 'bi-pencil-square' },
    { bg: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)', icon: 'bi-calculator' },
    { bg: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)', icon: 'bi-globe' },
    { bg: 'linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%)', icon: 'bi-lightbulb' },
    { bg: 'linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)', icon: 'bi-palette' },
    { bg: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)', icon: 'bi-music-note-beamed' },
  ];

  useEffect(() => {
    setLoading(true);
    const access_token = fetchAccessToken();

    getAllCommonStudentInitialData({ ep: '/student/student_homework_subject', token: access_token })
      .then((response) => {
        if (response && response?.data && response.data.data) {
          checkAccessTime(response, currentPath);
          setSubjectData(response.data.data);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  // Calculate total homework count
  const totalHomework = subjectData.reduce((sum, subject) => sum + (subject.no_of_homeworks || 0), 0);

  // Show loading state
  if (loading) {
    return (
      <div className="homework-subjects-page">
        <LoadingSpinner message="Loading subjects..." fullPage={true} />
      </div>
    );
  }

  return (
    <div className="homework-subjects-page">
      {/* Beautiful Header with Back Button */}
      <PageHeader
        title="Homework"
        subtitle="Select a subject to view homework"
        icon="journal-check"
        showBackButton={true}
        gradient="linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
        count={totalHomework}
        countLabel="Total Tasks"
      />

      {subjectData && subjectData.length > 0 ? (
        <Row className="g-4 homework-subjects-grid">
          {subjectData.map((v, i) => {
            const colorSet = subjectGradients[i % subjectGradients.length];

            return (
              <Col xs="6" sm="4" md="3" lg="2" key={i}>
                <Card
                  className="homework-subject-card"
                  onClick={() => {
                    history.push(`${window.location.pathname}/homework?subjectID=${v.id}`);
                  }}
                  style={{ animationDelay: `${i * 0.1}s` }}
                >
                  <div className="homework-subject-header" style={{ background: colorSet.bg }}>
                    <div className="homework-subject-icon">
                      <i className={`bi ${colorSet.icon}`}></i>
                    </div>
                    {v.no_of_homeworks > 0 && (
                      <div className="homework-count-badge">
                        <span>{v.no_of_homeworks}</span>
                      </div>
                    )}
                    <div className="homework-card-decoration"></div>
                  </div>
                  <Card.Body className="homework-subject-body">
                    <h5 className="homework-subject-title">{v.name}</h5>
                    <div className="homework-subject-action">
                      <span>View Homework</span>
                      <i className="bi bi-arrow-right"></i>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
        </Row>
      ) : (
        <NoDataFound
          title="No Subjects Available"
          message="Homework subjects will appear here once they are assigned by your teachers."
          icon="journal-check"
          showBackButton={true}
        />
      )}
    </div>
  );
};

export default SubjectsView;